import { z } from "zod";
const month = z.string().regex(/^(20\d{2}|[3-9]\d{3})-(0[1-9]|1[0-2])$/);
const amount = z.number().finite().nullable();
export const financeCarryRows = [
    { key: "openingCarry", label: "Opening deferred P&L" },
    { key: "statementVm", label: "Statement variation margin" },
    { key: "currentRecognized", label: "Current-month movement recognized" },
    { key: "currentDeferred", label: "Current-month movement carried forward" },
    { key: "unreconciledVm", label: "Unreconciled statement VM" },
    { key: "releasedCarry", label: "P&L released from earlier carry" },
    { key: "pnlRounding", label: "P&L display rounding" },
    { key: "recognizedPnl", label: "Total recognized P&L" },
    { key: "carryRounding", label: "Carry display rounding" },
    { key: "closingCarry", label: "Closing deferred P&L" },
];
export const FinanceCarryRowSchema = z.enum(["openingCarry", "statementVm", "currentRecognized", "currentDeferred", "unreconciledVm", "releasedCarry", "pnlRounding", "recognizedPnl", "carryRounding", "closingCarry"]);
export const FinanceCarryDetailSchema = z.object({
    row: FinanceCarryRowSchema, kind: z.string(), label: z.string(), amount,
    tradeId: z.string().nullable(), relatedTradeId: z.string().nullable(),
    contract: z.string().nullable(), quantity: z.number().finite().nullable(), unit: z.string().nullable(),
    recognitionMonth: month.nullable(), sourceMonth: month.nullable(),
    book: z.string().nullable(), trader: z.string().nullable(),
});
export const FinanceCarryValuesSchema = z.object({
    openingCarry: amount, statementVm: amount, currentRecognized: amount, currentDeferred: amount,
    unreconciledVm: amount, releasedCarry: amount, pnlRounding: amount, recognizedPnl: amount,
    carryRounding: amount, closingCarry: amount,
});
export const FinanceCarryReportSchema = z.object({
    schemaVersion: z.literal(1), companyId: z.string(), companyName: z.string(),
    generatedAt: z.string(), asOf: z.string(), inputVersion: z.string().regex(/^[a-f0-9]{64}$/),
    from: month, to: month,
    months: z.array(z.object({
        month,
        currencies: z.array(z.object({
            currency: z.string(), values: FinanceCarryValuesSchema,
            details: z.array(FinanceCarryDetailSchema),
            checks: z.array(z.object({ name: z.string(), status: z.enum(["pass", "review"]), detail: z.string() })),
            approval: z.object({ status: z.enum(["approved", "incomplete", "none"]), approvedEur: amount, currentEur: amount }),
        })),
    })),
    notes: z.array(z.string()),
});
/** Bound the synchronous company snapshot to two years; never accept a tenant in the query. */
export const FinanceCarryRangeSchema = z.object({ from: month, to: month }).strict().refine(value => {
    const index = (m) => Number(m.slice(0, 4)) * 12 + Number(m.slice(5, 7));
    return index(value.to) >= index(value.from) && index(value.to) - index(value.from) < 24;
}, { message: "Choose a range of one to 24 months, with the first month no later than the last.", path: ["to"] });
export const FinanceCarryExportQuerySchema = z.object({
    from: month, to: month, version: z.string().regex(/^[a-f0-9]{64}$/),
}).strict().refine(value => FinanceCarryRangeSchema.safeParse({ from: value.from, to: value.to }).success, { message: "Choose a valid range of one to 24 months.", path: ["to"] });
//# sourceMappingURL=eex-finance-carry.js.map